import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-center" }
const _hoisted_2 = { class: "w-75 content-center" }

import RegisterModal from "@/components/Common/RegisterModal.vue"
import { ref, computed, watch } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'IniFileGSensorSettingCustomModal',
  props: {
    modelValue: { type: Boolean },
    customValue: {},
    label: {}
  },
  emits: ['update:modelValue', 'update:customValue', 'clearCustomValue', 'saveCustomValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const customValue = ref(props.customValue);

const emit = __emit;

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

watch(customValue, (newValue) => {
    emit("update:customValue", newValue);
});

function cancel() {
  emit('update:modelValue', false);
  emit('clearCustomValue');
}

function saveValue() {
  emit('update:modelValue', false);
  emit('saveCustomValue');
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(RegisterModal, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue).value = $event)),
    modalMaxWidth: "45%",
    title: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.gSensor.customValuePrompt')
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_text_field, {
            class: "ma-2",
            label: __props.label,
            messages: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.gSensor.accelerationSettingHint'),
            modelValue: customValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customValue).value = $event)),
            type: "number",
            step: "0.1"
          }, null, 8, ["label", "messages", "modelValue"])
        ])
      ])
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_v_btn, {
        class: "ma-2 reset-btn",
        onClick: cancel
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.cancelBtn')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        class: "ma-2 exec-btn",
        onClick: saveValue
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.saveBtn')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})